module.exports = __webpack_public_path__ + "media/phone-8348ce93.png";